import React from 'react';
import './main.scss';

const Main = ({ lang, Children }) => {
  return (
    <main>
      <Children lang={lang} />
    </main>
  );
};

export default Main;
